'use strict';

module.exports = function (marty, React) {
  marty.createAppMixin = require('./createAppMixin')(React);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/marty-lib/modules/app-mixin/index.js
// module id = p6Ty
// module chunks = 88